import React from "react";
import { useTranslation } from "react-i18next";

interface FrequencySelectorProps {
  selectedFrequency?: string;
  onFrequencySelect?: (frequency: string) => void;
  isDisabled?: boolean;
  className?: string;
}

const FrequencySelector: React.FC<FrequencySelectorProps> = ({
  selectedFrequency,
  onFrequencySelect,
  isDisabled = false,
  className = "",
}) => {
  const { t } = useTranslation();

  const handleFrequencySelect = (frequency: string) => {
    if (onFrequencySelect) {
      onFrequencySelect(frequency);
    }
  };

  return (
    <div className={`space-y-2 ${className}`} data-testid="frequency-selector">
      <p className="font-bold">{t("sessionForm.sessionFrequency")}</p>

      <div
        className={`flex max-w-[476px] flex-wrap gap-4 ${
          isDisabled ? "opacity-50" : ""
        }`}
      >
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="none"
            className="peer hidden"
            checked={selectedFrequency === "none"}
            onChange={() => handleFrequencySelect("none")}
            disabled={isDisabled}
          />
          <span className="checkbox-group-item py-0">{t("sessionForm.doesNotRepeat")}</span>
        </label>
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="daily"
            className="peer hidden"
            checked={selectedFrequency === "daily"}
            onChange={() => handleFrequencySelect("daily")}
            disabled={isDisabled || true}
          />
          <span className="checkbox-group-item py-0">{t("sessionForm.daily")}</span>
        </label>
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="weekday"
            className="peer hidden"
            checked={selectedFrequency === "weekday"}
            onChange={() => handleFrequencySelect("weekday")}
            disabled={isDisabled || true}
          />
          <span className="checkbox-group-item py-0">{t("sessionForm.everyWeekday")}</span>
        </label>
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="weekly"
            className="peer hidden"
            checked={selectedFrequency === "weekly"}
            onChange={() => handleFrequencySelect("weekly")}
            disabled={isDisabled || true}
          />
          <span className="checkbox-group-item py-0">{t("sessionForm.weekly")}</span>
        </label>
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="monthly"
            className="peer hidden"
            checked={selectedFrequency === "monthly"}
            onChange={() => handleFrequencySelect("monthly")}
            disabled={isDisabled || true}
          />
          <span className="checkbox-group-item py-0">{t("sessionForm.monthly")}</span>
        </label>
        <label
          className={`flex ${
            isDisabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            type="radio"
            name="frequency"
            value="custom"
            className="peer hidden"
            checked={selectedFrequency === "custom"}
            onChange={() => handleFrequencySelect("custom")}
            disabled={isDisabled || true}
          />
          <span className="checkbox-group-item py-0">
            {t("sessionForm.customFrequencyExample")}
          </span>
        </label>
      </div>

      <div className={`${isDisabled ? "opacity-50" : ""}`}>
        <button
          className="btn btn-secondary mt-4"
          disabled={isDisabled || true}
        >
          <span>{t("sessionForm.customSessionFrequency")}</span>
        </button>
      </div>
    </div>
  );
};

export default FrequencySelector;
